/* global axios */

import ApiClient from './ApiClient';

class DealsAPI extends ApiClient {
  constructor() {
    super('deals', { accountScoped: true });
  }

  get(params = {}) {
    return axios.get(this.url, { params });
  }

  move(id, data) {
    return axios.patch(`${this.url}/${id}/move`, data);
  }

  createComment(id, data) {
    return axios.post(`${this.url}/${id}/comments`, data);
  }
}

export default new DealsAPI();
